// 根据最新简历归纳，来源与边界见 resume-self/profile/能力模型.md。
export const capabilityModel = {
    "title": "负责人能力模型",
    "headline": "定方向，建体系，带团队，交付结果",
    "intro": "以 AI 产研与技术统筹连接六项管理责任。点击节点，查看关键判断与已有成果。",
    "dimensions": [
        {
            "id": "direction",
            "short": "方向判断",
            "subtitle": "产品组合与优先级",
            "name": "业务判断与产品方向",
            "description": "把分散需求收敛成有价值的产品组合，明确阶段目标、验证路径与投入边界。",
            "decision": "哪些业务问题值得优先投入，做到什么程度才有继续投入的依据？",
            "mechanisms": [
                "围绕支付运营、用户经营与研发效率安排产品优先级。",
                "以小范围验证和业务验收反馈调整路线。"
            ],
            "result": "10 个模板题验收通过",
            "context": "智能问数把高频取数需求转化为可复用业务能力，标准题口径正确率 ≥90%。",
            "links": [
                {
                    "label": "智能问数",
                    "href": "#resume-project-0"
                },
                {
                    "label": "Aixera 职责",
                    "href": "#resume-experience-aixera"
                }
            ]
        },
        {
            "id": "technology",
            "short": "技术路线",
            "subtitle": "平台能力与系统边界",
            "name": "技术战略与平台架构",
            "description": "围绕业务演进确定自建、复用与平台化边界，让关键技术选择服务长期交付。",
            "decision": "哪些能力应沉淀为共用平台，哪些复杂度需要在架构层控制？",
            "mechanisms": [
                "规划知识平台、ADK 与工具接入等共用能力。",
                "统筹模型参与范围、系统职责、可靠运行与权限边界。"
            ],
            "result": "集团全部业务线使用",
            "context": "企业知识库形成共用知识能力；知识编译、检索与调查按方案及验证阶段分别表达。",
            "links": [
                {
                    "label": "企业知识库",
                    "href": "#resume-project-2"
                },
                {
                    "label": "LatticeFlow 数仓",
                    "href": "#resume-project-3"
                }
            ]
        },
        {
            "id": "resources",
            "short": "资源配置",
            "subtitle": "投入取舍与成本约束",
            "name": "资源配置与投入管理",
            "description": "结合业务优先级、研发资源和基础设施成本，决定投入顺序与阶段性取舍。",
            "decision": "投入如何匹配目标，如何用质量、效率和成本共同评估方案？",
            "mechanisms": [
                "组织游戏孵化的一年期模型、人力与基础设施投入测算。",
                "以复用、架构与采购取舍推进数据能力和成本优化。"
            ],
            "result": "≥ 86 万元 / 年",
            "context": "相关数据能力建设与成本优化的整体年度降本，不归为单一模块或个人独立成果。",
            "links": [
                {
                    "label": "Lattice 协同与成本",
                    "href": "#resume-project-0"
                },
                {
                    "label": "拳游统筹职责",
                    "href": "#resume-experience-ov"
                }
            ]
        },
        {
            "id": "organization",
            "short": "组织建设",
            "subtitle": "责任机制与人才培养",
            "name": "组织建设与人才培养",
            "description": "围绕目标和责任组织跨职能协作，通过评审与辅导提升团队独立判断和交付能力。",
            "decision": "如何让产品、研发、测试和运营对齐目标，并各自承担结果？",
            "mechanisms": [
                "明确优先级、职责分工与跨环节依赖，推进阻塞问题解决。",
                "组织招聘、培养、方案评审和成员辅导。"
            ],
            "result": "AI LAB + 数据团队",
            "context": "统筹 AI 应用、数据与算法建设；兼有 Aixera 技术负责及团队日常管理职责。",
            "links": [
                {
                    "label": "拳游工作经历",
                    "href": "#resume-experience-ov"
                },
                {
                    "label": "Aixera 工作经历",
                    "href": "#resume-experience-aixera"
                }
            ]
        },
        {
            "id": "governance",
            "short": "交付治理",
            "subtitle": "质量准入与风险处置",
            "name": "交付体系与质量治理",
            "description": "把质量要求转化为可执行的验收机制，在阶段交付和变更中保持风险、证据与制品对应。",
            "decision": "什么条件可以放行，哪些风险必须阻断，变更后需要重验什么？",
            "mechanisms": [
                "区分定义放行、实现验证与部署准入，明确风险处置条件。",
                "组织回归、验收与交付追溯，将验证证据用于交付决策。"
            ],
            "result": "定义 → 实现 → 准入",
            "context": "Game Factory 建立分阶段治理设计，并保留样本、恢复、幂等与隔离专项验证。",
            "links": [
                {
                    "label": "Game Factory 治理",
                    "href": "#resume-project-1"
                },
                {
                    "label": "问数验收",
                    "href": "#resume-project-0"
                }
            ]
        },
        {
            "id": "outcomes",
            "short": "结果复盘",
            "subtitle": "业务使用与持续演进",
            "name": "业务结果与持续演进",
            "description": "以真实使用、验收结果和评测反馈检验投入，推动产品、共用能力与交付方法持续演进。",
            "decision": "如何确认系统产生了实际价值，并把反馈转化为下一轮改进？",
            "mechanisms": [
                "结合业务使用、质量评测、时延与成本评估阶段成果。",
                "沉淀问题反馈、技术方案与代表性成果，支持复核与迭代。"
            ],
            "result": "452 题 · 正确性 0.825",
            "context": "企业知识库最新评测结果；业务使用范围、评测分数与线上效果保持各自口径。",
            "links": [
                {
                    "label": "知识库评测与应用",
                    "href": "#resume-project-2"
                },
                {
                    "label": "问数业务成果",
                    "href": "#resume-project-0"
                }
            ]
        }
    ]
};
